import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router";
import { CONSOLE_PATHS } from "@sagot/constants";
import { ServiceAreaSkeleton } from "../service-area-skeleton";

const FieldRoute = lazy(() => import("./field-route").then((module) => ({ default: module.FieldRoute })));

/** The engineer's phone screens (C23), lazy so they add nothing to the console's first load. The page title is the crumb. */
export const fieldRoutes: RouteObject[] = [
  {
    path: CONSOLE_PATHS.myDay,
    handle: { titleKey: "service.field.title" },
    element: (
      <Suspense fallback={<ServiceAreaSkeleton />}>
        <FieldRoute />
      </Suspense>
    ),
  },
];
